    <div class="response-container">
        <div class="modal-header">
            <h4 class="modal-title myprofile_modal_header" id="myModalLabel">{{"accountinfo.reqchangestext" | cxTranslate}}</h4>
            <button (click)="close()" type="button" class="myprofile_modalclose" data-dismiss="modal"
                aria-hidden="true">×</button>
        </div>
        <div class="modal-body">
            <p class="myprofile_modalbody_txt">{{"accountinfo.additionalmsg" | cxTranslate}} <a [routerLink]="['/contact-us']" (click)="close()">
                    <span class="mysupporttxt"><u>{{"accountinfo.custServicetext" | cxTranslate}}</u>
                    </span>.</a>
                    {{"accountinfo.additionalmsg2" | cxTranslate}} </p>
            <div class="row margin-T20">
                <div class="col-md-6 col-sm-6 col-xs-12">
                    <label class="myprofile_editbusinessinfo_txt">{{"accountinfo.companyDetaillabel" | cxTranslate}}</label>

                </div>
            </div>

            <div class="row margin-T10">
                <div class="col-md-6 col-sm-6 col-xs-12">
                    <label class="myprofile_editcompany_txt" for="company-name">{{"accountinfo.currCompanylabel" | cxTranslate}}</label>
                    <label class="myprofile_editmodalbusinessinfo_txt">{{data.company}}</label>
                </div>
                <div class="col-md-6 col-sm-6 col-xs-12">
                    <label class="myprofile_editcompany_txt" for="locations-count">{{"accountinfo.newCompanylabel" | cxTranslate}}</label>
                    <input #company (input)="getNewCompName(company.value)" class="myprofile_input form-control" id="billingOrgName" name="orgAddressForm.billingOrgName"
                        autocomplete="no">
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button [disabled]="company.value.trim().length==0" (click)="submitBusinessDetails()" type="button" class="btn btn-default myprofile_modalrequestbtn" id="request_change" value="">{{"accountinfo.reqchangestext" | cxTranslate}}</button>
        </div>
    </div>
